define('presentation/common/timeframe/viewModels/timeframeViewModel',[
    'moment-timezone',
    'constants/timeframeConstants'
], function() {
    return function () {
        const self = this;

        const _i18n = require('i18next');
        const _moment = require('moment-timezone');
        const _timeframeConstants = require('constants/timeframeConstants');

        let _settings = null;
        let _disposables = [];

        self.selectedOption = ko.observable(null);
        self.startOn = ko.observable();
        self.endOn = ko.observable();
        self.isAnalytics = ko.observable(false);
        self.placeholderMessage = ko.computed(() => self.isAnalytics() ? '' : _i18n.t('timeframe:all'));

        const _updateStartEndMoments = () => {
            if (self.isAnalytics()) {
                return;
            }

            if (self.selectedOption() === '') {
                self.startOn('');
                self.endOn('');
                return;
            }

            let startMoment = _moment.utc();
            let endMoment = startMoment.clone();
            
            switch (self.selectedOption()) {
                case _timeframeConstants.today:
                    startMoment.startOf('day');
                    endMoment.startOf('day').add(1, 'days');
                    break;
                case _timeframeConstants.thisWeek:
                    startMoment.startOf('week');
                    endMoment.startOf('week').add(1, 'weeks');
                    break;
                case _timeframeConstants.thisMonth:
                    startMoment.startOf('month');
                    endMoment.startOf('month').add(1, 'months');
                    break;
                case _timeframeConstants.thisQuarter:
                    startMoment.startOf('quarter');
                    endMoment.startOf('quarter').add(1, 'quarter');
                    break;
                case _timeframeConstants.thisYear:
                    startMoment.startOf('year');
                    endMoment.startOf('year').add(1, 'years');
                    break;
                case _timeframeConstants.yesterday:
                    startMoment.startOf('day').subtract(1, 'days');
                    endMoment.startOf('day');
                    break;
                case _timeframeConstants.lastWeek:
                    startMoment.startOf('week').subtract(7, 'days');
                    endMoment.startOf('week');
                    break;
                case _timeframeConstants.lastMonth:
                    startMoment.startOf('month').subtract(1, 'months');
                    endMoment.startOf('month');
                    break;
                case _timeframeConstants.lastQuarter:
                    startMoment.startOf('quarter').subtract(1, 'quarters');
                    endMoment.startOf('quarter');
                    break;
                case _timeframeConstants.lastYear:
                    startMoment.startOf('year').subtract(1, 'years');
                    endMoment.startOf('year');
                    break;
                case _timeframeConstants.monthToDate:
                    startMoment.startOf('month');
                    endMoment.startOf('day').add(1, 'days');
                    break;
                case _timeframeConstants.quarterToDate:
                    startMoment.startOf('quarter');
                    endMoment.startOf('day').add(1, 'days');
                    break;
                case _timeframeConstants.yearToDate:
                    startMoment.startOf('year');
                    endMoment.startOf('day').add(1, 'days');
                    break;
                case _timeframeConstants.lastDays7:
                    startMoment.startOf('day').subtract(6, 'days');
                    endMoment.startOf('day').add(1, 'days');
                    break;
                case _timeframeConstants.lastDays14:
                    startMoment.startOf('day').subtract(13, 'days');
                    endMoment.startOf('day').add(1, 'days');
                    break;
                case _timeframeConstants.lastDays30:
                    startMoment.startOf('day').subtract(29, 'days');
                    endMoment.startOf('day').add(1, 'days');
                    break;
                case _timeframeConstants.lastDays60:
                    startMoment.startOf('day').subtract(59, 'days');
                    endMoment.startOf('day').add(1, 'days');
                    break;
                case _timeframeConstants.lastDays90:
                    startMoment.startOf('day').subtract(89, 'days');
                    endMoment.startOf('day').add(1, 'days');
                    break;
                case _timeframeConstants.lastMonths12:
                    startMoment.startOf('day').subtract(12, 'months');
                    endMoment.startOf('day').add(1, 'days');
                    break;
                case _timeframeConstants.custom:
                    return;
            }

            self.startOn(startMoment.format("MM/DD/YYYY"));
            self.endOn(endMoment.format("MM/DD/YYYY"));
        };

        self.showDateRangeSelector = ko.pureComputed(() => self.selectedOption() === 'custom');
        self.showClearButton = ko.pureComputed(() => {
            return self.isAnalytics() === false &&
                self.selectedOption() !== null &&
                self.selectedOption() !== '';
        });

        self.timeframeOptions = [
            {text: _i18n.t('timeframe:today'), id: _timeframeConstants.today},
            {text: _i18n.t('timeframe:thisWeek'), id: _timeframeConstants.thisWeek},
            {text: _i18n.t('timeframe:thisMonth'), id: _timeframeConstants.thisMonth},
            {text: _i18n.t('timeframe:thisQuarter'), id: _timeframeConstants.thisQuarter},
            {text: _i18n.t('timeframe:thisYear'), id: _timeframeConstants.thisYear},
            {text: _i18n.t('timeframe:yesterday'), id: _timeframeConstants.yesterday},
            {text: _i18n.t('timeframe:lastWeek'), id: _timeframeConstants.lastWeek},
            {text: _i18n.t('timeframe:lastMonth'), id: _timeframeConstants.lastMonth},
            {text: _i18n.t('timeframe:lastQuarter'), id: _timeframeConstants.lastQuarter},
            {text: _i18n.t('timeframe:lastYear'), id: _timeframeConstants.lastYear},
            {text: _i18n.t('timeframe:monthToDate'), id: _timeframeConstants.monthToDate},
            {text: _i18n.t('timeframe:quarterToDate'), id: _timeframeConstants.quarterToDate},
            {text: _i18n.t('timeframe:yearToDate'), id: _timeframeConstants.yearToDate},
            {text: _i18n.t('timeframe:lastDays7'), id: _timeframeConstants.lastDays7},
            {text: _i18n.t('timeframe:lastDays14'), id: _timeframeConstants.lastDays14},
            {text: _i18n.t('timeframe:lastDays30'), id: _timeframeConstants.lastDays30},
            {text: _i18n.t('timeframe:lastDays60'), id: _timeframeConstants.lastDays60},
            {text: _i18n.t('timeframe:lastDays90'), id: _timeframeConstants.lastDays90},
            {text: _i18n.t('timeframe:lastMonths12'), id: _timeframeConstants.lastMonths12},
            {text: _i18n.t('timeframe:custom'), id: _timeframeConstants.custom},
        ];

        self.clearSelectedOption = () => {
            self.selectedOption('');
        };

        self.detached = () => {
            _disposables.forEach((disposable) => {
                disposable.dispose();
            });

            _disposables = [];
        };

        self.activate = (settings) => {
            _settings = settings;

            _initialize(settings);
        };

        const _initialize = () => {
            self.selectedOption = _settings.timeframeOption;

            if (ko.isObservable(_settings.startOn) && ko.isObservable(_settings.endOn) === false) {
                throw new Error('date parameters must be observable');
            }

            self.startOn = _settings.startOn;
            self.endOn = _settings.endOn;

            if (_settings.isAnalytics) {
                self.isAnalytics(ko.unwrap(_settings.isAnalytics));
            }

            _disposables.push(self.selectedOption.subscribe(_updateStartEndMoments));
        };
    };
});
